module.exports = __webpack_public_path__ + "img/carteirinhaVerso.660ad16e.jpeg";